export const NOT_ENABLE_REQUESTER_ON_PORTAL_CALLEDS = 0;